import { ThemedView } from '@app/theme';


const RadioV2 = ({ isSelected , size = 18 }: { label?: string, isSelected: boolean, onPress?: () => void , size?: number }) => {

    const radioSize = size * 0.6;

    return (
        <ThemedView height={size} width={size} borderRadius='full' borderWidth={1} borderColor={isSelected ? 'bg-action-primary' : 'border-primary'} justifyContent='center' alignItems='center' backgroundColor='bg-fill-primary'>
            <ThemedView height={radioSize} width={radioSize} borderRadius='full' backgroundColor={isSelected ? 'bg-action-primary' : 'bg-fill-primary'} />
        </ThemedView>
    )
}   

export default RadioV2;
